import React from 'react'

import './styles.css'


const Footer = () => {

    const dateCurrent = new Date();

    return (
        <div className="footer-container">
            <div className="footer-content">
                <h1 className="footer-rights">Coe Dados Engenharia - {dateCurrent.getFullYear()}</h1>
            </div>
        </div>
    );
}

export default Footer;
